import { useEffect, useState } from 'react';
import { getActivity, logActivity } from '../../services/adminMockData';

export default function AdminSettingsPage() {
  const adminName = sessionStorage.getItem('walkin_admin_name') || 'Admin';
  const adminRole = sessionStorage.getItem('walkin_admin_role') || '';
  const [activity, setActivity] = useState(() => getActivity());

  useEffect(() => {
    const t = setInterval(() => setActivity(getActivity()), 5000);
    return () => clearInterval(t);
  }, []);

  const resetDemo = () => {
    if (!window.confirm('Reset alle admin demo-data? Dit verwijdert mock-winkeliers, facturen en activity log.')) return;
    ['walkin_admin_shops', 'walkin_admin_invoices', 'walkin_admin_token_log',
     'walkin_admin_areas', 'walkin_admin_activity'].forEach((k) => localStorage.removeItem(k));
    logActivity('Demo data gereset');
    window.location.reload();
  };

  return (
    <div>
      <header className="admin-page-head">
        <div>
          <h1 className="admin-page-title">Instellingen</h1>
          <p className="admin-page-sub">Admin account en platform configuratie</p>
        </div>
      </header>

      <div className="admin-card">
        <div className="admin-card__title">Account</div>
        <div className="admin-form-row">
          <div className="admin-field">
            <span className="admin-field__label">Naam</span>
            <div>{adminName}</div>
          </div>
          <div className="admin-field">
            <span className="admin-field__label">Rol</span>
            <span className="admin-badge admin-badge--unlimited">{adminRole}</span>
          </div>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card__title">Audit log (laatste 20)</div>
        {activity.length === 0 ? (
          <div className="admin-empty">Nog geen activiteit gelogd.</div>
        ) : (
          <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
            {activity.slice(0, 20).map((a) => (
              <li key={a.id} style={{ padding: '10px 0', borderBottom: '1px solid #F1F2F4', fontSize: 13 }}>
                <strong>{a.admin}</strong> · {a.action}
                {a.meta && Object.keys(a.meta).length > 0 && (
                  <span style={{ color: '#6B7280', marginLeft: 6, fontSize: 12 }}>
                    {Object.entries(a.meta).map(([k, v]) => `${k}: ${v}`).join(' · ')}
                  </span>
                )}
                <span style={{ float: 'right', color: '#9CA3AF', fontSize: 12 }}>
                  {new Date(a.at).toLocaleString('nl-NL', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="admin-card">
        <div className="admin-card__title">Demo data</div>
        <p style={{ margin: 0, fontSize: 13, color: '#4B5563' }}>
          Reset alle admin mock-data om de panel opnieuw te seeden met verse winkeliers, facturen en gebieden.
        </p>
        <div style={{ marginTop: 14 }}>
          <button className="admin-btn admin-btn--danger" onClick={resetDemo}>
            Reset alle demo data
          </button>
        </div>
      </div>
    </div>
  );
}
